if ( jQuery.fn.autocomplete.noConflict ) {
	var autocomplete = jQuery.fn.autocomplete.noConflict();
	jQuery.fn.algolia_autocomplete = autocomplete;
}
